export const PAGE_NAMES = {
    HOME: "home",
    ABOUT: "about",
    POSTS: "posts",
    PROJECTS: "projects", 
    FOUR_ZERO_FOUR: "404",
    DEFAULT: "default"
}